import type {
	PromoCampaignCreateModel,
	PromoCampaignModel,
	PromoCampaignUpdateModel,
} from '@/shared/generated'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError } from 'axios'

import { useMutation } from '@tanstack/react-query'

import { client } from '@/shared/api/client'

export const mergeBy =
	(result: PromoCampaignModel) => (old?: PromoCampaignModel[]) => [
		...(old || []),
		result,
	]
export function useCreatePromoCampaignMutation(
	options?: UseMutationOptions<
		PromoCampaignModel,
		AxiosError,
		PromoCampaignCreateModel
	>
) {
	return useMutation<PromoCampaignModel, AxiosError, PromoCampaignCreateModel>({
		mutationFn: (payload) => client.promoCampaigns.createPromoCampaign(payload),
		...(options || {}),
	})
}

export function useUpdatePromoCampaignMutation(
	options?: UseMutationOptions<
		PromoCampaignModel,
		AxiosError,
		{ promoCampaignId: string; data: PromoCampaignUpdateModel }
	>
) {
	return useMutation<
		PromoCampaignModel,
		AxiosError,
		{ promoCampaignId: string; data: PromoCampaignUpdateModel }
	>({
		mutationFn: (payload) =>
			client.promoCampaigns.updatePromoCampaign(
				{ promoCampaignId: payload.promoCampaignId },
				payload.data
			),
		...(options || {}),
	})
}
export function useDeletePromoCampaignMutation(
	options?: UseMutationOptions<void, AxiosError, string>
) {
	return useMutation<void, AxiosError, string>({
		mutationFn: (promoCampaignId) =>
			client.promoCampaigns.deletePromoCampaign({ promoCampaignId }),
		...(options || {}),
	})
}
